module.exports = __webpack_public_path__ + "static/media/EthanBogle.50a9c79e.png";